/* eslint-disable @typescript-eslint/no-explicit-any */
import { useQuery } from "@tanstack/react-query";
import { fetchPlayerTeams } from "./profileTabsApi";
import { EmptyState, QueryState } from "./ProfileCommon";
import { getPlayerImageUrl } from "../../../helper/helper";

const ProfileTeamsTab = ({ playerId }: { playerId: string }) => {
  const q = useQuery({ queryKey: ["profileTeams", playerId], queryFn: () => fetchPlayerTeams(playerId), enabled: !!playerId });
  const teams = q.data ?? [];
  return (
    <div className="pt-root">
      <QueryState loading={q.isLoading} error={q.isError} onRetry={() => q.refetch()}>
        {teams.length === 0 ? (
          <EmptyState title="No teams yet" hint="Teams this player is part of will appear here." />
        ) : (
          <div className="pt-team-grid">
            {teams.map((t: any, i: number) => {
              const w = t.winMatchesCount ?? 0, l = t.lossMatchesCount ?? 0, d = t.drawMatchesCount ?? 0;
              return (
                <article className="pt-team" key={t.teamSnapshotId ?? t.teamId ?? i}>
                  <div className="pt-team-head">
                    {t.imageUrl ? <img src={getPlayerImageUrl(t.imageUrl) ?? ""} alt="" /> : <span className="pt-team-ph">{(t.teamName ?? "?").charAt(0)}</span>}
                    <div>
                      <h4>{t.teamName}</h4>
                      {t.tournamentName && <p className="pt-muted">{t.tournamentName}</p>}
                    </div>
                  </div>
                  <div className="pt-chips">
                    <span className="pt-chip">Played <b>{w + l + d}</b></span>
                    <span className="pt-chip">Won <b>{w}</b></span>
                    <span className="pt-chip">Lost <b>{l}</b></span>
                    <span className="pt-chip">Tie <b>{d}</b></span>
                  </div>
                </article>
              );
            })}
          </div>
        )}
      </QueryState>
    </div>
  );
};

export default ProfileTeamsTab;
